import React from 'react';

import { CalendarEvents } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { PersonalCalendarEventRead } from '@ragu-components/ord-types';

const CalendarEventsList = React.lazy(async () => import('./CalendarEventsList'));

export const personalCalendarEventsResource: OrdResourceProps = {
  key: `me/${CalendarEvents}`,
  name: `me/${CalendarEvents}`,
  list: <CalendarEventsList />,
  options: {},
  recordRepresentation: (record: PersonalCalendarEventRead): string => record.title,
};
